import React from 'react';
import classnames from 'classnames';

import classes from './Modal.scss';

type Props = {
    isOpen?: boolean;
    onDismiss();
    isMob: boolean;
    className?: string;
};

export const ModalStatic: React.FC<React.PropsWithChildren<Props>> = ({
    isOpen = false,
    onDismiss,
    className,
    children,
}) => {
    return (
        <>
            <div
                className={classnames(className, {
                    [classes.modalStatic]: true,
                    [classes.modalStaticActive]: isOpen,
                })}
                data-smooth-scroll="ModalStatic"
            >
                {isOpen && children}
            </div>
            {isOpen && (
                <button
                    className={[classes.modalOverlay, classes.modalOverlayStatic].join(' ')}
                    type="button"
                    onClick={onDismiss}
                >
                    &nbsp;
                </button>
            )}
        </>
    );
};
